import './App.css';
import './assets/vendor/bootstrap/css/bootstrap.min.css'
import './assets/vendor/bootstrap-icons/bootstrap-icons.css'
import './assets/vendor/boxicons/css/boxicons.min.css'
import './assets/vendor/glightbox/css/glightbox.min.css'
import Header from './Components/Header';
import Hero from './Components/Hero';
import Main from './Components/Main';
import ThemeToggle from './Components/ThemeToggle';
import { ThemeProvider } from './context/ThemeContext';
import AOS from "aos";
import "aos/dist/aos.css";

AOS.init();

function App() {
  return (
    <ThemeProvider>
      <div className="App">
        <ThemeToggle />
        <Header />
        <Hero />
        <Main />
      </div>
    </ThemeProvider>
  );
}

export default App;
